// extracted by mini-css-extract-plugin
module.exports = {"container":"passwords_container__1zXI0","button":"passwords_button__1Ibmw"};